export default __webpack_public_path__ + "static/media/samuelDubose.9128f188.png";